import { UnidadeGestoraResumida } from "@/types/ug/unidade-gestora-resumida";

export class FiltrosProrrogacoes {
    buscaGeral?: string
    exercicio?: number
    referencia?: number
    tipoProrrogacao?: string
    selectedUG: UnidadeGestoraResumida | null
    mes?: number

    limpar(): void {
        this.buscaGeral = undefined
        this.exercicio = undefined
        this.referencia = undefined
        this.tipoProrrogacao = undefined
        this.selectedUG = null 
    }

    toFormData(): FormData {
        const data = new FormData()
        if (this.buscaGeral)
            data.append("filtro", this.buscaGeral)
        if (this.exercicio)
            data.append("exercicio", String(this.exercicio))
        if (this.referencia !== undefined && this.referencia !== null)
            data.append("referencia", String(this.referencia))
        if (this.tipoProrrogacao !== undefined && this.tipoProrrogacao !== null){
            //data.append("tipo", String(this.tipoProrrogacao))   
            data.append("tipoProrrogacao", String(this.tipoProrrogacao))                           
        }
        if (this.selectedUG !== undefined && this.selectedUG !== null)
            data.append("idUG", String(this.selectedUG?.IdPCM))                        
        return data
    }
}